<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 유해위험방지계획서 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 유해위험방지계획서</h5>
      <div class="writeGridContainer">
        <div>
          <div>설치장소</div>
          <p v-if="isPrint" class="print-input"> {{ form.설치장소 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.설치장소" :max="300" :visible-counter="true" />
        </div>
        <div>
          <div>대상설비</div>
          <p v-if="isPrint" class="print-input"> {{ form.대상설비 }}</p>
          <custom-option-selector v-else :readonly="board.readonly" :isPrint="isPrint" :options="result_options" v-model="form.대상설비" />
        </div>
        <div>
          <div>설비용량</div>
          <p v-if="isPrint" class="print-input"> {{ form.설비용량 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.설비용량" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>제출사유</div>
          <p v-if="isPrint" class="print-input"> {{ form.제출사유 }}</p>
          <custom-option-selector v-else :readonly="board.readonly" :isPrint="isPrint" :options="result_options2" v-model="form.제출사유" />
        </div>
        <div>
          <div>유해위험방지계획서 첨부</div>
          <p v-if="isPrint" class="print-input">{{ form.유해위험방지계획서첨부 ? form.유해위험방지계획서첨부.fileName : "" }}</p>
          <FileUploader v-else :readonly="board.readonly" v-model="form.유해위험방지계획서첨부" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";

export default {
  components: {
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    CustomOptionSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      result_options: ["용해로", "화학설비", "건조설비", "가스집합용접장치", "밀폐·환기·배기를 위한 설비"],
      result_options2: ["신규 설치", "주요구조 변경", "이전"],

      form: {
        stdInfo: {},
        fileList: [],

        설치장소: "",
        대상설비: "",
        설비용량: "",
        제출사유: "",
        유해위험방지계획서첨부: {},
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
};
</script>
